import CliqueiAcheiLogoWithPowered from '@app/components/Icons/CliqueiAcheiLogoWithPowered';
import LogoCardapioDoBarriga from '@app/components/Icons/LogoCardapioDoBarriga';
import ShareButton from '@app/components/ShareButton';
import { Colors } from '@app/config/colors';
import DIMENSIONS from '@app/config/dimensions';
import { useBagContext } from '@app/contexts/Bag';
import { useRestaurantContext } from '@app/pages/Restaurant/context';
import { useIsTabletOrMobileScreenSize } from '@app/utils/media-query';
import { IconButton } from '@material-ui/core';
import { Close, FeedbackOutlined, Search, YouTube } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import style from './appbar.module.css';
import { AppBarRightSide } from './styles';

type Props = {
  isBarrigaPageModel: boolean;
  onSearch: (term: string) => void;
  onCloseSearch: () => void;
  onFeedbackClick: () => void;
  onYoutubeClick: () => void;
  displayYoutubeButton: boolean;
  isLoggedInClientArea: boolean;
};

export default function AppBar({
  isBarrigaPageModel,
  onSearch,
  onCloseSearch,
  onFeedbackClick,
  onYoutubeClick,
  displayYoutubeButton,
  isLoggedInClientArea,
}: Props) {
  const isTabletOrMobile = useIsTabletOrMobileScreenSize();

  const { primaryColor, secondaryColor } = useRestaurantContext();

  const [searchIsActived, setSearchIsActived] = useState(false);
  const [term, setTerm] = useState('');

  const isTableOrMobile = useIsTabletOrMobileScreenSize();

  useEffect(() => {
    if (!isTableOrMobile) {
      setSearchIsActived(false);
      setTerm('');
    }
  }, []);

  useEffect(() => {
    if (searchIsActived && isTableOrMobile) onSearch(term);
  }, [term]);

  function handleSearchClick() {
    if (searchIsActived) {
      setSearchIsActived(false);
      setTerm('');
      onCloseSearch();
    } else {
      setSearchIsActived(true);
    }
  }

  const logoStyle = { height: DIMENSIONS.APP_BAR.HEIGHT - (isTableOrMobile ? 30 : 20) };

  return (
    <div
      className={style.appBarTop}
      style={{ backgroundColor: primaryColor ?? Colors.DefaultPrimaryColor, height: DIMENSIONS.APP_BAR.HEIGHT }}
    >
      <div className={style.container}>
        {searchIsActived ? (
          <input
            className={style.searchInput}
            style={{ borderColor: secondaryColor, color: secondaryColor }}
            autoFocus
            value={term}
            onChange={(e) => setTerm(e.target.value)}
          />
        ) : (
          <div className={style.logoSVG} style={{ height: DIMENSIONS.APP_BAR.HEIGHT }}>
            {isBarrigaPageModel ? (
              <LogoCardapioDoBarriga style={logoStyle} color={secondaryColor} />
            ) : (
              <CliqueiAcheiLogoWithPowered style={logoStyle} color={secondaryColor} />
            )}
          </div>
        )}
        <AppBarRightSide>
          {!searchIsActived && (
            <>
              {displayYoutubeButton && (
                <IconButton onClick={onYoutubeClick}>
                  <YouTube style={{ color: secondaryColor }} />
                </IconButton>
              )}
              <ShareButton color={secondaryColor} />
              {!isLoggedInClientArea && (
                <IconButton onClick={onFeedbackClick}>
                  <FeedbackOutlined style={{ color: secondaryColor }} />
                </IconButton>
              )}
            </>
          )}
          {isTabletOrMobile && (
            <IconButton onClick={handleSearchClick} style={{ marginRight: -10 }}>
              {searchIsActived ? (
                <Close style={{ color: secondaryColor }} />
              ) : (
                <Search style={{ color: secondaryColor }} />
              )}
            </IconButton>
          )}
        </AppBarRightSide>
      </div>
    </div>
  );
}
